// extracted by mini-css-extract-plugin
export default {"video":"VideoViewer_video__nEWpy","error":"VideoViewer_error__ftmST"};